import page404 from '~/assets/images/bg/404-page.png';
import illustration404 from '~/assets/images/bg/404-illustration.png';
function NotFound() {
    return (
        <div className="px-3">
            <div className="min-vh-100 flex-center p-5 row">
                <div className="col-xxl-8 col-xl-10 col-12">
                    <div className="justify-content-center align-items-center g-5 row">
                        <div className="text-center order-lg-1 col-lg-6 col-12">
                            <img alt="" width="400" className="img-fluid w-lg-100 d-dark-none" src={illustration404}/>
                        </div>
                            <div className="text-center text-lg-start col-lg-6 col-12">
                                <img className="img-fluid mb-6 w-50 w-lg-75 d-dark-none" alt=""
                                src={page404}/>
                                <h2 className="text-body-secondary fw-bolder mb-3">Page Missing!</h2><p
                                className="text-body mb-5">But no worries! Our ostrich is looking everywhere<br
                                className="d-none d-sm-block"/>while you wait safely.</p><a role="button" tabIndex="0"
                                                                                            href="/home" type="button"
                                                                                            className="btn btn-primary btn-lg"
                                                                                            data-discover="true">Go Home</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NotFound;